import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/installation-image-comment.svg'


const _hoisted_1 = { class: "flex h-full overflow-y-auto flex-col gap-3" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_5 = ["onClick", "id", "src"]
const _hoisted_6 = {
  key: 0,
  class: "absolute bottom-0 right-0"
}

import { FocusImage } from "@/types";
import { watch, nextTick, ref } from "vue";

type Props = {
  selectedImage: FocusImage | null;
  steps: any;
};

type Emits = {
  (event: "setSelectedImage", image: FocusImage): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'FocusModeModalImages',
  props: {
    selectedImage: {},
    steps: {}
  },
  emits: ["setSelectedImage"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const selectedImage = ref<FocusImage | null>(null);

const handleSelectedImage = (
  image: any,
  stepId: any,
  inputId: any,
  repeatableInputIndex?: number
) => {
  let newFocusedImage: FocusImage = {
    logId: image.logId,
    imageUrl: image.imageUrl,
    comment: image.comment,
    inputId: inputId,
    stepId: stepId,
    repeatableGroupIndex: image.repeatableGroupIndex,
    repeatableInputIndex: repeatableInputIndex,
    terminId: image.terminId,
    workers: image.workers,
    createdAt: image.createdAt,
  };
  emits("setSelectedImage", newFocusedImage);
};

watch(
  () => props.selectedImage,
  async (newImage) => {
    if (newImage?.logId) {
      await nextTick();
      const element = document.getElementById(`image-${newImage.logId}`);
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  },
  { immediate: true }
);

watch(
  () => props.selectedImage,
  (newImage) => {
    selectedImage.value = newImage ? { ...newImage } : null;
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps.filter((step)=> step.inputs.filter((input) =>(input.subtype === 'image' && input.value && input.value?.length > 0) || 
       (input.type === 'image' && input.value && input.value.length > 0)).length > 0), (step) => {
      return (_openBlock(), _createElementBlock("div", {
        key: step.id,
        id: step.id,
        class: "rounded-primary-radius flex flex-col items-center justify-center cursor-pointer hover:opacity-100 duration-300 gap-3 mb-[24px]"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input)=> (input.subtype === 'image' || input.type === 'image') && input.value && input.value.length > 0), (input) => {
          return (_openBlock(), _createElementBlock("div", {
            key: input.id,
            id: input.id,
            class: "w-full flex flex-col"
          }, [
            (input.value && input.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.value, (image) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: image.logId,
                      class: _normalizeClass(["relative flex flex-col w-[50px] h-[50px]", 
              props.selectedImage?.logId === image.logId
                ? 'opacity-100'
                : 'opacity-30'
            ])
                    }, [
                      _createElementVNode("img", {
                        onClick: ($event: any) => (handleSelectedImage(image, step.id, input.id)),
                        id: `image-${image.logId}`,
                        class: _normalizeClass(["w-full h-full object-cover rounded-primary-radius", 
                props.selectedImage?.logId === image.logId
                  ? 'border-[3px] border-[#393840]'
                  : 'border-transparent'
              ]),
                        loading: "lazy",
                        src: image.imageUrl,
                        alt: "Image"
                      }, null, 10, _hoisted_5),
                      (
                selectedImage.value?.logId === image?.logId && selectedImage.value?.comment
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                              class: "w-[17px] h-[17px]",
                              src: _imports_0,
                              alt: "Commment"
                            }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        }), 128))
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})